import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
`;

const Close = styled.span`
  backface-visibility: hidden;
  height: 25px;
  position: absolute;
  right: 0;
  top: 0;
  transition: transform 0.2s;
  width: 25px;

  &:before {
    background-color: white;
    content: '';
    height: 2px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    width: 25px;
  }

  &:after {
    background-color: white;
    content: '';
    height: 2px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) rotate(135deg);
    width: 25px;
  }

  &:hover {
    transform: rotate(45deg);
  }
`;

const Canvas = styled.canvas`
  backface-visibility: hidden;
  background: rgba(0, 0, 0, 0.35);
  bottom: 0;
  cursor: pointer;
  left: 0;
  opacity: ${props => props.showControls ? 1 : 0};
  right: 0;
  position: absolute;
  transition: opacity 0.6s;
  width: 100%;
  z-index: 999;
`;

class Playbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { playing: false };
    this.clear = this.clear.bind(this);
    this.drawProgress = this.drawProgress.bind(this);
    this.seek = this.seek.bind(this);
    this.duration = null;
    this.video = this.props.videoRef;
    this.video.addEventListener('loadeddata', () => {
      this.duration = this.props.videoRef.duration;
      window.requestAnimationFrame(this.clear);
    });
    this.lastPosition = null;
  }

  componentDidMount() {
    this.setState({ playing: true });
    this.duration = this.props.videoRef.duration;
    this.clear();
    window.requestAnimationFrame(this.drawProgress, true);
  }

  seek(e) {
    e.stopPropagation();
    const rect = this.canvas.getBoundingClientRect();
    const position = (e.clientX - rect.left) / this.canvas.width;
    this.lastPosition = position;
    this.props.videoRef.currentTime = this.duration * position;
    this.clear();
    this.drawProgress(true);
  }

  clear() {
    try {
      this.ctx = this.canvas.getContext('2d');
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    } catch (error) {
      return;
    }
  }

  drawProgress(redraw) {
    try {
      const progress = this.props.videoRef.currentTime / this.duration;
      const position = Math.floor(progress * this.canvas.width);

      //return when no progression has taken place since last update
      if (position === this.lastPosition) {
        window.requestAnimationFrame(this.drawProgress);
        return;
      }

      //video has restarted. clear canvas
      if (position < this.lastPosition) {
        this.clear();
        this.ctx = this.canvas.getContext('2d');
        this.ctx.fillStyle = 'White';
        this.ctx.fillRect(0, 0, 1, this.canvas.height);
        this.lastPosition = position;
        window.requestAnimationFrame(this.drawProgress);
        return;
      }

      this.ctx = this.canvas.getContext('2d');
      this.ctx.fillStyle = 'White';
      if (redraw) this.ctx.fillRect(0, 0, position, this.canvas.height);
      else this.ctx.fillRect(this.lastPosition, 0, position - this.lastPosition, this.canvas.height);
      this.lastPosition = position;
      window.requestAnimationFrame(this.drawProgress);
    } catch (error) {
      return;
    }
  }

  render() {
    return (
      <Canvas
        showControls={this.props.showControls}
        onClick={this.seek}
        width={this.props.width}
        height={12}
        innerRef={e => this.canvas = e}
      />
    );
  }
}

const Video = styled.video`
  backface-visibility: hidden;
  height: 100%;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
`;

const AspectRatio = styled.div`
  height: 0;
  padding-top: 56.25%;
`;

const VideoWrapper = styled.div`
  animation-delay: 0.4s;
  animation-duration: 0.2s;
  animation-name: ${fadeIn};
  animation-fill-mode: forwards;
  background-color: black;
  left: 50%;
  max-width: 60rem;
  opacity: 0;
  overflow: hidden;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%) translateZ(999px) !important;
  width: 100vw;
  z-index: 999;
`;

export class FullscreenVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = { width: null, showControls: true };
    this.updateWidth = this.updateWidth.bind(this);
    this.showControls = this.showControls.bind(this);
  }

  showControls() {
    this.setState({ showControls: true });
    window.clearTimeout(this.showTimeout);
    this.showTimeout = window.setTimeout(() => {
      this.setState({ showControls: false });
    }, 2000);
  }

  componentDidMount() {
    this.videoElement.play();
    this.updateWidth();
    this.showTimeout = window.setTimeout(() => {
      this.setState({ showControls: false });
    }, 2000);
  }

  componentWillUnmount() {
    window.clearTimeout(this.showTimeout);
  }

  updateWidth() {
    this.setState({ width: this.videoElement.offsetWidth });
  }

  render() {
    return (
      <VideoWrapper innerRef={e => this.DOMElement = e}>
        <AspectRatio>
          <Video onMouseEnter={this.showControls} innerRef={e => this.videoElement = e} loop>
            <source src={this.props.element.video} type="video/mp4" />
          </Video>
        </AspectRatio>
        {this.videoElement && 
          <Playbar showControls={this.state.showControls} width={this.state.width} videoRef={this.videoElement} />
        }
      </VideoWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FullscreenVideo.js